/** Display and dial links for the main customer service line (전화 상담 팝업). */
export const PHONE_DISPLAY = "(718) 762-6488";
export const PHONE_TEL_HREF = "tel:+17187626488";
